import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function BoldHeaderSplitTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden" data-testid="resume-live-preview">
      <div className="p-7" style={{ backgroundColor: accent }}>
        <h1 className="text-2xl font-bold text-white">{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-white/85 text-sm font-semibold mt-0.5">{draft.target_role}</p>}
        <p className="text-white/75 text-xs mt-1.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
        {draft.skills.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {draft.skills.map((sk) => <span key={sk} className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-white/15 text-white">{sk}</span>)}
          </div>
        )}
      </div>
      <div className="grid grid-cols-3 gap-5 p-7">
        <div className="col-span-2">
          {draft.summary && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Summary</h2>
              <p className="text-slate-700 mt-1">{draft.summary}</p>
            </div>
          )}
          {draft.experience.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
              {draft.experience.map((e, i) => (
                <div key={i} className="mt-2">
                  <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                  <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="col-span-1 border-l pl-5" style={{ borderColor: `${accent}25` }}>
          {draft.education.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
              {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1.5 text-[12px]">{ed.degree} {ed.field}<br /><span className="text-slate-500">{ed.school}</span></p>)}
            </div>
          )}
        </div>
      </div>
      <div className="px-7 pb-7">
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
